export const Layout = () => import('@/layout/index.vue')

const routes = {
  path: '/product',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Goods',
    title: '产品中心',
    roles: ['admin/product.Category/list', 'admin/product.Product/list', 'admin/price.Base/list', 'admin/material.Material/list'],
    activeMenuTop: '/product',
    hidden: false,
    keepAlive: true,
    alwaysShow: true
  },
  children: [
    {
      path: 'category',
      name: 'ProductCategory',
      redirect: 'noRedirect',
      meta: {
        icon: 'FolderOpened',
        title: '产品分类',
        roles: ['admin/product.Category/list'],
        activeMenuTop: '/product',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'ProductCategoryList',
          component: () => import('@/views/product/category/list.vue'),
          meta: {
            icon: 'FolderOpened',
            title: '产品分类',
            roles: ['admin/product.Category/list'],
            activeMenuTop: '/product',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'ProductCategoryInfo',
          component: () => import('@/views/product/category/info.vue'),
          meta: {
            title: '产品分类信息',
            roles: ['admin/product.Category/info'],
            activeMenu: '/product/category/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add/:pid?',
          name: 'ProductCategoryAdd',
          component: () => import('@/views/product/category/add.vue'),
          meta: {
            title: '产品分类添加',
            roles: ['admin/product.Category/add'],
            activeMenu: '/product/category/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'ProductCategoryEdit',
          component: () => import('@/views/product/category/edit.vue'),
          meta: {
            title: '产品分类修改',
            roles: ['admin/product.Category/edit'],
            activeMenu: '/product/category/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'product',
      name: 'ProductProduct',
      redirect: 'noRedirect',
      meta: {
        icon: 'Goods',
        title: '产品管理',
        roles: ['admin/product.Product/list'],
        activeMenuTop: '/product',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'ProductProductList',
          component: () => import('@/views/product/product/list.vue'),
          meta: {
            icon: 'Goods',
            title: '产品管理',
            roles: ['admin/product.Product/list'],
            activeMenuTop: '/product',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'ProductProductInfo',
          component: () => import('@/views/product/product/info.vue'),
          meta: {
            title: '产品信息',
            roles: ['admin/product.Product/info'],
            activeMenu: '/product/product/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'ProductProductAdd',
          component: () => import('@/views/product/product/add.vue'),
          meta: {
            title: '产品添加',
            roles: ['admin/product.Product/add'],
            activeMenu: '/product/product/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'ProductProductEdit',
          component: () => import('@/views/product/product/edit.vue'),
          meta: {
            title: '产品修改',
            roles: ['admin/product.Product/edit'],
            activeMenu: '/product/product/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'price',
      name: 'ProductPrice',
      redirect: 'noRedirect',
      meta: {
        icon: 'Wallet',
        title: '价格管理',
        roles: ['admin/price.Base/list', 'admin/price.Process/list'],
        activeMenuTop: '/product',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'PriceManageList',
          component: () => import('@/views/price/manage.vue'),
          meta: {
            icon: 'Wallet',
            title: '价格管理',
            roles: ['admin/price.Base/list'],
            activeMenuTop: '/product',
            hidden: false,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'base/info/:id',
          name: 'PriceBaseInfo',
          component: () => import('@/views/price/base/info.vue'),
          meta: {
            title: '基础价格信息',
            roles: ['admin/price.Base/info'],
            activeMenu: '/product/price/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'base/add',
          name: 'PriceBaseAdd',
          component: () => import('@/views/price/base/add.vue'),
          meta: {
            title: '基础价格添加',
            roles: ['admin/price.Base/add'],
            activeMenu: '/product/price/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'base/edit/:id',
          name: 'PriceBaseEdit',
          component: () => import('@/views/price/base/edit.vue'),
          meta: {
            title: '基础价格修改',
            roles: ['admin/price.Base/edit'],
            activeMenu: '/product/price/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'process/info',
          name: 'PriceProcessInfo',
          component: () => import('@/views/price/process/info.vue'),
          meta: {
            title: '工艺加价信息',
            roles: ['admin/price.Process/info'],
            activeMenu: '/product/price/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'process/add',
          name: 'PriceProcessAdd',
          component: () => import('@/views/price/process/add.vue'),
          meta: {
            title: '工艺加价添加',
            roles: ['admin/price.Process/add'],
            activeMenu: '/product/price/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        },
        {
          path: 'process/edit',
          name: 'PriceProcessEdit',
          component: () => import('@/views/price/process/edit.vue'),
          meta: {
            title: '工艺加价修改',
            roles: ['admin/price.Process/edit'],
            activeMenu: '/product/price/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: true,
            alwaysShow: false
          }
        }
      ]
    },
    {
      path: 'material',
      name: 'ProductMaterial',
      redirect: 'noRedirect',
      meta: {
        icon: 'Box',
        title: '材质管理',
        roles: ['admin/material.Material/list'],
        activeMenuTop: '/product',
        hidden: false,
        keepAlive: false,
        alwaysShow: false
      },
      children: [
        {
          path: 'list',
          name: 'MaterialMaterialList',
          component: () => import('@/views/material/material/list.vue'),
          meta: {
            icon: 'Box',
            title: '材质管理',
            roles: ['admin/material.Material/list'],
            activeMenuTop: '/product',
            hidden: false,
            keepAlive: false,
            alwaysShow: false
          }
        },
        {
          path: 'info/:id',
          name: 'MaterialMaterialInfo',
          component: () => import('@/views/material/material/info.vue'),
          meta: {
            title: '材质信息',
            roles: ['admin/material.Material/info'],
            activeMenu: '/product/material/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: false,
            alwaysShow: false
          }
        },
        {
          path: 'add',
          name: 'MaterialMaterialAdd',
          component: () => import('@/views/material/material/add.vue'),
          meta: {
            title: '材质添加',
            roles: ['admin/material.Material/add'],
            activeMenu: '/product/material/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: false,
            alwaysShow: false
          }
        },
        {
          path: 'edit/:id',
          name: 'MaterialMaterialEdit',
          component: () => import('@/views/material/material/edit.vue'),
          meta: {
            title: '材质修改',
            roles: ['admin/material.Material/edit'],
            activeMenu: '/product/material/list',
            activeMenuTop: '/product',
            hidden: true,
            keepAlive: false,
            alwaysShow: false
          }
        }
      ]
    }
  ]
}

export default routes